export const getNumberComa = (x) => {
  if (x !== null && x !== undefined && x !== "") {
    let number = Number(x);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
